import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  termsCheckboxLabel: {
    id: 'LcNUMI',
    defaultMessage: 'I agree to the {termsLink}',
    description: 'Checkbox label for accepting terms, with an embedded link to the Terms & Conditions page',
  },
  termsLinkText: {
    id: 'wpnst8',
    defaultMessage: 'Terms & Conditions',
    description: 'Link text for the Terms & Conditions page',
  },
});
